<template>
    <h6>Основные данные</h6>
    <argon-input
        id="fullName"
        v-model="fullName"
        :value="fullName"
        placeholder="ФИО"
        :isRequired="true"
        @input="updateFullName"
        :blurAction="searchInBlackList"
    />

  <div class="text-warning text-sm" v-if="blackList.length > 0">НАЙДЕНЫ СОВПАДЕНИЯ ИЗ ЧЕРНОГО СПИСКА:
    <div v-for="(item, index) in blackList" :key="index">
      {{index + 1}}. {{item.client.fullName }} - {{item.reason}}
    </div>
  </div>

    <div class="input-container">
      <label for="birthdate">Дата рождения</label>
      <input
          id="birthdate"
          v-model="birthday"
          @input="updateClientBirthdate"
          type="date"
          placeholder="Дата рождения"
      />
    </div>

    <argon-checkbox
        v-if="!isEditable"
        v-model="legalData"
        :checked="legalData"
        @click="updateClientLegalData"
        style=" margin-top: 10px;"
        id="checkboxId">Юридическое лицо
    </argon-checkbox>
  <div v-if="isEditable" style="margin-top: 16px;"></div>
</template>

<script>
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import ArgonInput from "../../../components/ArgonInput.vue";
import axios from "@/axios";

export default {
  name: 'ClientFirstStep',
  components: {ArgonInput, ArgonCheckbox},
  data() {
    return {
      blackList: [],
    };
  },
  computed: {
    fullName: {
      get() {
        return this.$store.state.clientCreateFullName;
      },

    },

    legalData: {
      get() {
        return this.$store.state.clientCreateLegalData;
      },
    },
    birthday: {
      get() {
        return this.$store.state.clientCreateBirthday;
      },
    },
    isEditable: {
      get() {
        return this.$store.state.clientIsEditable;
      }
    },

  },
  methods: {

    searchInBlackList() {
      if(this.fullName != "") {
        let url = '/api/clients/get-blacklist?search=' + this.fullName;
        axios.get(url).then(response => {
          let list = response.data.data;
          this.blackList = list;

        }).catch(error => {
          console.error("Ошибка загрузки данных: ", error);
        });
      }
      else {
        this.blackList = [];
      }
    },

    updateFullName(payload) {
      this.$store.commit('updateClientCreateFullName', payload.target.value);
    },
    updateClientLegalData(payload) {
      if (!payload.isBoolean) {
        this.$store.commit('updateClientCreateLegalData', !this.$store.state.clientCreateLegalData);
      }
      else {
        this.$store.commit('updateClientCreateLegalData', payload);
      }
      if (this.legalData) {
        this.$store.commit('updateClientTotalSteps', 3);
      } else {
        this.$store.commit('updateClientTotalSteps', 2);
      }
    },
    updateClientBirthdate(payload) {
      this.$store.commit('updateClientBirthday', payload.target.value);
    },
  }
}
</script>

<style scoped>

#birthdate {
  border: 1px solid #d2d6da;
  color: #495057;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.input-container {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
}

</style>